import {
  MESSAGE_SENDER,
  MESSAGE_TYPES,
  // BUTTON_SUB_TYPES,
  BUTTON_TYPES,
} from "./constants"

export const getDefaultMessagesByKey = (key = "web") => {
  const defaultMessgaes = {
    web: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: '',
          subtitle:
            'Hej! Welcome to IKEA UAE. Consider me as your go-to guide. how can I help you?',
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Offers',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Services',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Store information',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Track order',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'FAQ',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Click & collect',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Order Inquiry',
              url: '',
            },
          ],
          btnDisplayCount: 6,
        },
        timestamp: new Date(),
      },
    ],
    android: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: false,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: '',
        delay: 0,
        payload: {
          text: 'Hej! Welcome to IKEA UAE. Consider me as your go-to guide. how can I help you?',
        },
        timestamp: new Date(),
      },
      {
        // inputType: "currency", // type = "currency/phone/date"
        // inputProps: {
        //   placeholder: "Enter salary",
        //   prefix: "₹",
        //   maxLength: 10,
        // },
        cmid: "message2",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: '',
          subtitle: 'What can I help you with?',
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Track online order',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'FAQ',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Store information',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Services',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Click & collect',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Order Inquiry',
              url: '',
            },
            {
              type: BUTTON_TYPES.LINK,
              text: 'Ideas & Inspiration',
              url: 'https://www.ikea.com/ae/en/ideas/home-furnishings/?chatbotopen=false',
            },
          ],
        },
        timestamp: new Date(),
      }
    ],
    ar: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: '',
          subtitle:
            'مرحبا! اهلاً بك في ايكيا الإمارات العربية المتحدة. اعتبرني دليلك المفضل',
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'معلومات المتجر', //store info
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'الأسئلة المتداولة', //faq
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'تتبع الطلبات', //order tracking
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'خدمات', //services
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'عروض', //online offers
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'انقر وجمع',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'استعلام عن الطلب',
              url: '',
            },
          ],
          btnDisplayCount: 6,
        },
        timestamp: new Date(),
      },
    ],
    eg_en: [
      {
        cmid: "message2",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: '',
          subtitle: 'Hej! Welcome to IKEA Egypt. Consider me as your go-to guide. how can I help you?',
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Offers',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Services',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Store information',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Track order',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'FAQ',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Click & collect',
            },
          ],
          btnDisplayCount: 5,
        },
        timestamp: new Date(),
      },
    ],
    eg_ar: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: '',
          subtitle: 'مرحبا! اهلاً بك في ايكيا مصر اعتبرني دليلك المفضل.',
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'معلومات المتجر',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'استفسار عن طلب',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'الخدمات',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'الأسئلة الشائعة',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'عروض', //Offers
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'الطلب والاستلام', //Order and receive
              url: '',
            },
          ],
          btnDisplayCount: 8,
        },
        timestamp: new Date(),
      },
    ],
    qa_en: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: '',
          subtitle:
          'Hej! Welcome to IKEA Qatar. Consider me as your go-to guide. how can I help you?',
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Offers',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Services',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Store information',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Track order',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'FAQ',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Click & collect',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Order Inquiry',
              url: '',
            },
          ],
          btnDisplayCount: 6,
        },
        timestamp: new Date(),
      },
    ],
    qa_ar: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: '',
          subtitle:
          'مرحبا! اهلاً بك في ايكيا قطر اعتبرني دليلك المفضل.',
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'معلومات المتجر',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'الأسئلة الشائعة',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'انقر واستلم',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'الخدمات',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'عروض',
              url: '',
            },
          ],
          btnDisplayCount: 6,
        },
        timestamp: new Date(),
      },
    ],
    om_en: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: '',
          subtitle:
            'Hej! Welcome to IKEA Oman. Consider me as your go-to guide. how can I help you?',
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Offers',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Services',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Store information',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'FAQ',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Click & collect',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'Order Inquiry',
              url: '',
            },
          ],
          btnDisplayCount: 5,
        },
        timestamp: new Date(),
      },
    ],
    om_ar: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: '',
          subtitle:
            'مرحبا! اهلاً بك في ايكيا عُمان اعتبرني دليلك المفضل',
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'معلومات المتجر',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'الاستفسار عن الطلب',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'عروض', //Offers
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'الخدمات',
              url: '',
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: 'الأسئلة الشائعة',
              url: '',
            },
          ],
          btnDisplayCount: 6,
        },
        timestamp: new Date(),
      },
    ],
  }
  return defaultMessgaes[key] || []
}
